"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSLSpreadsheet = void 0;
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-bind */
var core_money_1 = require("@newfront-insurance/core-money");
var core_ui_1 = require("@newfront-insurance/core-ui");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var dsl_schema_ui_1 = require("@newfront-insurance/dsl-schema-ui");
var schema_display_1 = require("@newfront-insurance/dsl-schema-ui/dist/src/components/schema-display");
var utils_1 = require("@newfront-insurance/dsl-schema-ui/dist/src/components/schema-display/utils");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importStar(require("react"));
var use_spreadsheet_1 = require("../hooks/use-spreadsheet");
var table_1 = require("../table");
var no_results_1 = require("../table/no-results");
var spreadsheet_cell_1 = require("../table/spreadsheet-cell");
var table_loading_body_1 = require("../table/table-loading-body");
var tbody_1 = require("../table/tbody");
var dsl_editable_popover_1 = require("./dsl-editable-popover");
var footer_column_1 = require("./footer-column");
var identifier_actions_1 = require("./identifier-actions");
var utils_2 = require("./utils");
function DSLSpreadsheet(_a) {
    var identifierActions = _a.identifierActions, accountUuid = _a.accountUuid, schema = _a.schema, data = _a.data, _b = _a.loading, loading = _b === void 0 ? false : _b, additionalColumns = _a.additionalColumns, additionalCellRender = _a.additionalCellRender, _c = _a.rowsToShow, rowsToShow = _c === void 0 ? 8 : _c, heightProp = _a.height, _d = _a.rowHeight, rowHeight = _d === void 0 ? 80 : _d, tableOptions = _a.tableOptions, _e = _a.options, options = _e === void 0 ? {
        isEditable: false,
    } : _e, tableId = _a.tableId, onColumnClick = _a.onColumnClick, onColumnUpdate = _a.onColumnUpdate, globalFilter = _a.globalFilter, _f = _a.expandable, expandable = _f === void 0 ? false : _f, _g = _a.expandSubrows, expandSubrows = _g === void 0 ? false : _g, _h = _a.hideExpandColumn, hideExpandColumn = _h === void 0 ? false : _h, overrideFieldRender = _a.overrideFieldRender, styleOptions = _a.styleOptions, propTestId = _a.testId;
    var columns = (0, react_1.useMemo)(function () {
        var schemaColumns = schemaToColumns(schema, accountUuid, identifierActions, additionalCellRender, overrideFieldRender, options.isEditable || false, onColumnUpdate);
        if (!additionalColumns || additionalColumns.length === 0) {
            return schemaColumns;
        }
        return (0, utils_2.insertColumns)(schemaColumns, additionalColumns);
    }, [
        schema,
        accountUuid,
        additionalColumns,
        identifierActions,
        options.isEditable,
        additionalCellRender,
        overrideFieldRender,
        onColumnUpdate,
    ]);
    var _j = (0, use_spreadsheet_1.useSpreadsheet)({
        data: data,
        columns: columns,
        height: heightProp,
        tableOptions: tableOptions,
        rowsToShow: rowsToShow,
        tableId: tableId,
        globalFilter: globalFilter,
        options: options,
        rowHeight: rowHeight,
        expandable: expandable,
        expandSubrows: expandSubrows,
        hideExpandColumn: hideExpandColumn,
    }), table = _j.table, virtual = _j.virtual, height = _j.height;
    var getTableProps = table.getTableProps, getTableBodyProps = table.getTableBodyProps, prepareRow = table.prepareRow, rows = table.rows, headerGroups = table.headerGroups, footerGroups = table.footerGroups, totalColumnsWidth = table.totalColumnsWidth;
    var outerRef = virtual.outerRef, innerRef = virtual.innerRef, items = virtual.items;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : tableId;
    function handleCellClick(row, cellValue, columnId, cellIndex) {
        if (onColumnClick) {
            onColumnClick({ row: row, cellValue: cellValue, columnId: columnId, cellIndex: cellIndex });
        }
    }
    var hasResults = rows.length > 0;
    if (!hasResults && !loading) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(table_1.Table, __assign({}, getTableProps(), { isSticky: !expandable, style: {
                    maxHeight: height,
                    minHeight: loading ? 300 : 'auto',
                }, testId: testId }),
                react_1.default.createElement(table_1.THead, { headerGroups: headerGroups, borderTop: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.borderTop, testId: testId }),
                react_1.default.createElement(tbody_1.TBody, __assign({}, getTableBodyProps(), { testId: testId }),
                    react_1.default.createElement(no_results_1.NoResults, null)))));
    }
    return (react_1.default.createElement(table_1.ScrollableTableContainer, { height: heightProp },
        react_1.default.createElement(table_1.Table, __assign({}, getTableProps(), { isSticky: !expandable, style: {
                maxHeight: heightProp ? '100%' : height,
                minHeight: loading || !hasResults ? 300 : 'auto',
            }, ref: outerRef, testId: testId }),
            react_1.default.createElement(table_1.THead, { headerGroups: headerGroups, style: {
                    minWidth: totalColumnsWidth,
                }, borderTop: (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.borderTop) !== undefined ? styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.borderTop : true, testId: testId }),
            react_1.default.createElement(tbody_1.TBody, __assign({}, getTableBodyProps(), { ref: innerRef, style: {
                    minWidth: totalColumnsWidth,
                }, testId: testId }),
                !hasResults && !loading && react_1.default.createElement(no_results_1.NoResults, null),
                loading && react_1.default.createElement(table_loading_body_1.TableLoadingBody, { ref: outerRef }),
                hasResults && !loading && (react_1.default.createElement(react_1.default.Fragment, null, items.map(function (_a) {
                    var _b;
                    var index = _a.index, size = _a.size;
                    var row = rows[index];
                    if (!row) {
                        return null;
                    }
                    prepareRow(row);
                    return (react_1.default.createElement(table_1.Row, __assign({}, row.getRowProps({
                        style: {
                            height: size,
                        },
                    }), { testId: (0, core_ui_1.generateTestId)(testId, (_b = row.id) !== null && _b !== void 0 ? _b : row.index) }), row.cells.map(function (cell, index) { return (react_1.default.createElement(spreadsheet_cell_1.SpreadsheetCell, { key: cell.column.id, cell: cell, row: row, index: index, onCellClick: handleCellClick, cellBackground: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.rowBackground, testId: testId })); })));
                })))),
            hasResults && !loading && !expandable && (react_1.default.createElement(table_1.TFoot, { footerGroups: footerGroups, style: {
                    minWidth: totalColumnsWidth,
                } })))));
}
exports.DSLSpreadsheet = DSLSpreadsheet;
/**
 * Function that reads the schema and converts into table columns
 *
 * @param schema
 * @returns Column[]
 */
function schemaToColumns(schema, accountUuid, identifierActions, additionalCellRender, overrideFieldRender, isEditable, onColumnUpdate) {
    var _this = this;
    var _a;
    var spreadsheetColumns = ((_a = schema.spreadsheet) === null || _a === void 0 ? void 0 : _a.columns) || [];
    var columns = [];
    var identifier = schema.identifier;
    if (identifier) {
        var identifierColumn = {
            Header: 'Identifier',
            id: 'identifier',
            width: 250,
            disableSortBy: true,
            focusable: false,
            Cell: function (_a) {
                var row = _a.row;
                return (react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", style: {
                        cursor: 'pointer',
                        height: '100%',
                        background: '#fff',
                    } },
                    react_1.default.createElement(schema_display_1.SchemaIdentifierDisplay, { schema: schema, values: row.original.data, displayName: row.original.displayName }),
                    identifierActions && react_1.default.createElement(identifier_actions_1.IdentifierActions, { actions: identifierActions(row.original) })));
            },
            Footer: function (footer) {
                var rows = footer.rows;
                return (react_1.default.createElement(core_ui_1.Text, { weight: 600, color: "light", style: {
                        whiteSpace: 'nowrap',
                    } },
                    rows.length,
                    " records"));
            },
        };
        columns.push(identifierColumn);
    }
    var otherColumns = spreadsheetColumns.map(function (spreadsheetColumn) {
        var spreadsheetColumnName = spreadsheetColumn.fieldName;
        var schemaProperty = (0, get_1.default)(schema, (0, utils_1.getNestedFieldNameSchemaProperty)(spreadsheetColumnName));
        var accessor = "data.".concat(spreadsheetColumnName);
        return {
            Header: (schemaProperty === null || schemaProperty === void 0 ? void 0 : schemaProperty.inputMetadata.label) || 'No label',
            id: accessor,
            accessor: (function (row) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, dsl_schema_ui_1.getStringifiedFieldValue)((0, get_1.default)(row.data || {}, spreadsheetColumnName), schemaProperty);
            }),
            focusable: !!isEditable,
            CellPopover: function (_a) {
                var cellRef = _a.cellRef, isOpen = _a.isOpen, close = _a.close, cell = _a.cell, row = _a.row;
                var handleSubmit = (0, react_1.useCallback)(function (values) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!onColumnUpdate) return [3 /*break*/, 2];
                                return [4 /*yield*/, onColumnUpdate({ row: cell.row.original, payload: values, columnId: accessor })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                close();
                                return [2 /*return*/];
                        }
                    });
                }); }, [close, cell.row.original]);
                if (isOpen) {
                    return (react_1.default.createElement(dsl_editable_popover_1.DSLEditablePopover, { initialValues: {
                            data: row.original.data,
                        }, onSubmit: handleSubmit, propertyKey: spreadsheetColumnName, cellRef: cellRef, onClose: close, accountUuid: accountUuid, schema: schema }));
                }
                return null;
            },
            Cell: function (_a) {
                var row = _a.row, column = _a.column;
                var additionalCellRenderFn = additionalCellRender === null || additionalCellRender === void 0 ? void 0 : additionalCellRender[spreadsheetColumnName];
                var overrideFieldRenderFn = overrideFieldRender === null || overrideFieldRender === void 0 ? void 0 : overrideFieldRender[spreadsheetColumnName];
                var fieldOverride = overrideFieldRenderFn
                    ? overrideFieldRenderFn({
                        row: row.original,
                        propertyName: spreadsheetColumnName,
                    })
                    : undefined;
                if (row.canExpand) {
                    return null;
                }
                if (fieldOverride) {
                    return fieldOverride;
                }
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { style: {
                            overflow: 'hidden',
                        } },
                        react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 2 },
                            react_1.default.createElement(dsl_schema_ui_1.SchemaDisplayItemValue, { name: spreadsheetColumnName, schema: schema, values: row.original.data }))),
                    additionalCellRenderFn &&
                        additionalCellRenderFn({
                            row: row.original,
                            propertyName: spreadsheetColumnName,
                        })));
            },
            Footer: function (footer) {
                return (react_1.default.createElement(footer_column_1.FooterColumn, { accessor: accessor, footer: footer, schemaProperty: schemaProperty, footerType: spreadsheetColumn.footer }));
            },
            sortType: getSchemaSortType(schemaProperty),
        };
    });
    columns.push.apply(columns, otherColumns);
    return columns;
}
/**
 * DSL fields may have specific sorting logic, we may need to add a few more IFs here if the default
 * alphanumeric does not work.
 *
 * @param field
 * @returns SortByFn | DefaultSortTypes
 */
function getSchemaSortType(field) {
    if (field.inputType === dsl_schema_api_1.InputType.CURRENCY) {
        return function (rowA, rowB, columnKey) {
            var valueA = rowA.values[columnKey];
            var valueB = rowB.values[columnKey];
            return ((0, core_money_1.numberFromMoney)(valueA) || 0) - ((0, core_money_1.numberFromMoney)(valueB) || 0);
        };
    }
    if (field.inputType === dsl_schema_api_1.InputType.DATE) {
        return function (rowA, rowB, columnKey) {
            var valueA = rowA.values[columnKey];
            var valueB = rowB.values[columnKey];
            return new Date(valueA).getTime() - new Date(valueB).getTime();
        };
    }
    return 'alphanumeric';
}
